
import { defineComponent } from "vue"
export default defineComponent({
  setup() {
    return {
      title: document.title,
    }
  },
})
